import React, { useMemo } from "react";
import ActivityButton3D from "../Buttons/ActivityButton3D";
import { TextBoxWithFlag, Flag, Text } from "../Subtitles/TextBoxWithFlag";
import { ES } from "country-flag-icons/react/3x2";
import VideoPlayer from "../Video/VideoPlayer";
import { FillActivity, Option } from "@shared_types";
import { LessonHeaderHeightPx } from "./LessonHeader";
import { useDivSize } from "@/hooks/UseDivSize";

interface FillProps {
  fillInTheBlankActivity: FillActivity;
  onActivityFinished: () => void;
  lessonId: number;
  onTrackListeningTime: (time: number) => void;
  isHorizontal: boolean;
}

const shuffleOptions = (options: Option[]): Option[] => {
  return options.sort(() => Math.random() - 0.5);
};

const Fill: React.FC<FillProps> = ({
  fillInTheBlankActivity,
  onActivityFinished,
  onTrackListeningTime,
  isHorizontal,
}) => {
  const fill = fillInTheBlankActivity.fillInTheBlank;
  const startTime = fillInTheBlankActivity.start;
  const endTime = fillInTheBlankActivity.end;
  const options = useMemo(() => shuffleOptions(fill.options), [fill.options]);
  const handleClick = (selectedOption: Option) => {
    if (selectedOption.correct) {
      onActivityFinished();
    }
  };

  const { ref: fillPageRef, height: fillPageHeight } = useDivSize();
  const { ref: fillContentRef, height: fillContentHeight } = useDivSize();

  let fillContentStyleHeight = "var(--fill-content-height)";
  if (isHorizontal) {
    fillContentStyleHeight = "calc(var(--fill-content-height) + 30px)";
  }

  const bottomPadding: string = "10px";
  
  const videoPlayerHeight = `${
    fillPageHeight - fillContentHeight - LessonHeaderHeightPx + 32
  }px`;

  return (
    <div
      ref={fillPageRef}
      className="relative flex flex-col justify-between items-center max-w-[700px] w-full h-full"
    >
      <VideoPlayer
        youtubeId={fillInTheBlankActivity.youtubeId}
        onTimeUpdate={() => {}}
        startTime={startTime}
        endTime={endTime}
        onPlay={() => {}}
        onTrackListeningTime={onTrackListeningTime}
        isHorizontal={isHorizontal}
        videoPlayerHeight={videoPlayerHeight}
      />
      <div
        ref={fillContentRef}
        className="absolute bottom-0 pb-4 flex items-center flex-grow justify-end w-full h-full bg-[#fafafa] rounded-t-xl"
        style={{
          minHeight: fillContentStyleHeight,
          height: "auto",
          paddingBottom: bottomPadding,
        }}
      >
        <div className="w-full h-full flex flex-col items-center justify-center flex-grow px-4 py-1 gap-2">
          <div className="w-full text-lg font-bold">
            Listen and fill in the blank
          </div>
          <div className="w-full rounded-xl bg-[#fafafa]">
            <TextBoxWithFlag>
              <Flag>
                <ES title="Spain" className="w-8" />
              </Flag>
              <Text>{fill.question}</Text>
            </TextBoxWithFlag>
          </div>
          <div className="flex flex-col gap-2 w-full items-center pt-3">
            {options.map((option) => (
              <ActivityButton3D
                key={option.choice}
                text={option.choice}
                isCorrect={option.correct}
                onClick={() => handleClick(option)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fill;
